export default {
  "content": "<path d=\"M41 20.1v8.3L10.1 46.2v-8.3L41 20.1z\" fill=\"#E02D2D\"/><path d=\"M10.1 37.9L7 36.2l30.9-17.8 3.1 1.8-30.9 17.7z\" fill=\"#E02D2D\"/><path d=\"M40.9 11.8v8.3L10.1 37.9v-8.3l30.8-17.8z\" fill=\"#FFD000\"/><path d=\"M10.1 29.7L7 27.9l30.9-17.8 3.1 1.8-30.9 17.8z\" fill=\"#FFD000\"/><path d=\"M40.9 3.6v8.3L10.1 29.7v-8.3L40.9 3.6z\" fill=\"#E02D2D\"/><path d=\"M10.1 36.9V21.4L40.9 3.6l-3.1-1.8L7 19.6V44.5l3.1 1.8v-9.4z\" fill=\"#1D1D1B\"/><path d=\"M20.3 15.6L40.8 3.8l.1 24.6-20.7 11.9-10 5.7-.1-24.6 10.2-5.8z\" stroke=\"#1D1D1B\" stroke-width=\".236\" stroke-miterlimit=\"10\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};